import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function Mission() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={`flex flex-col md:flex-row items-center bg-green-600 py-4 pb-32 ${loaded ? 'slide-in' : ''}`}>
       <img
          src="images/mission4.jpg"
          className="mx-4 md:px-12 w-72  md:w-full rounded-lg object-cover h-64 md:h-96"
          alt="Image Description"
       />


      <div className="text-center pb-8">
        <h1 className="text-3xl font-bold py-4 text-black font-home">OUR MISSION</h1>
        <p className="px-4 text-xl text-center font-semibold "> 
        To move Kenyans towards sustainable security, safety, and peace. This could involve initiatives such as educational programs, community dialogues,and environmental conservation. By collaborating with us and local stakeholders, a concerted effort can be made to build a safer and more peaceful society to everyone including those in need.

        </p>
        
        <div className="py-4 flex items-center justify-center">
          <Link to="/about">
            <button className='px-16 bg-red-700 rounded-md py-2 text-black font-bold text-lg transition-transform transform hover:scale-110'>Read More</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Mission;
